import { render, staticRenderFns } from "./SetPriceMobile.vue?vue&type=template&id=4cc9ba86"
import script from "./SetPriceMobile.vue?vue&type=script&lang=js"
export * from "./SetPriceMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports